export const salesForce = {
  SALESFORCE_URL: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&",
};
